/* ==========================================================================
   PRFORM Oslo Fade
   Background fade is now pure CSS (linear-gradient on #MainContent).
   This file handles:
     1. Header text/logo inversion — JS fallback for browsers that do not
        support animation-timeline: scroll(). Supporting browsers use the
        CSS scroll-driven animation in prform-homepage.css instead.
     2. Oslo Fade body background snap.
   Homepage only — loaded conditionally from theme.liquid.

   Scroll reveal lives in prform-reveal.js, which loads on every page.
   ========================================================================== */

(function () {
  'use strict';

  var TEXT_LIGHT = 'rgb(237,232,227)'; /* --text-on-dark  #EDE8E3 */
  var TEXT_DARK  = 'rgb(15,15,15)';    /* --text-on-light #0F0F0F */

  /* ------------------------------------------------------------------
     1. Header text inversion
        CSS scroll-driven animation handles this in Chrome 115+ / FF 110+.
        This block runs only in browsers without that support.
     ------------------------------------------------------------------ */
  var cssScrollSupported = CSS && CSS.supports && CSS.supports('animation-timeline', 'scroll()');

  if (!cssScrollSupported) {
    var headerComponent = document.querySelector('header-component');
    var headerRows      = document.querySelectorAll('#header-group .header__row');

    function applyHeaderColor(color) {
      if (headerComponent) {
        headerComponent.style.color = color;
        headerComponent.style.setProperty('--color-foreground', color);
        headerComponent.style.setProperty('--color-foreground-heading', color);
        headerComponent.style.setProperty('--color-icon', color);
      }
      for (var r = 0; r < headerRows.length; r++) {
        headerRows[r].style.color = color;
      }
    }

    /* Initialise: hero is at top, background is bone white → dark text */
    applyHeaderColor(TEXT_DARK);

    window.addEventListener('scroll', function () {
      /* Invert when scrolled past 80% of the viewport height */
      applyHeaderColor(window.scrollY > window.innerHeight * 0.8 ? TEXT_LIGHT : TEXT_DARK);
    }, { passive: true });
  }
})();


/* ==========================================================================
   Oslo Fade — body background snap
   Adds/removes .oslo-dark on document.body once scroll passes the hero
   AND 70% into the Collection section. Falls back to end of hero if
   .prform-collection is not found.
   ========================================================================== */

(function () {
  var hero       = document.querySelector('.prform-hero');
  var collection = document.querySelector('.prform-collection');
  if (!hero) return;

  function update() {
    var dark;
    if (collection) {
      /* Trigger when the midpoint of the Collection section enters the viewport */
      var rect = collection.getBoundingClientRect();
      dark = (rect.top + collection.offsetHeight / 2) < window.innerHeight;
    } else {
      dark = window.scrollY > hero.offsetTop + hero.offsetHeight;
    }
    document.body.classList.toggle('oslo-dark', dark);
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
}());
